import { z } from "zod"

export const powurOsWarrantySchema = z.object({
  id: z.number().int(),
  equipmentId: z.number().int(),
  twentyFiveYearExtendedWarrantyPrice: z.number(),
  twentyYearExtendedWarrantyPrice: z.number(),
})
export type PowurOsWarranty = z.infer<typeof powurOsWarrantySchema>
